import React, { PureComponent } from 'react';
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    timestamp: {
        color: '#666666',
        marginTop: 8,
        marginBottom: 8,
        fontWeight: 400,
        fontSize: 12,
        fontFamily: "DinforPBR",
        lineHeight: 16/12,
    },
}));

class TimestampCard extends PureComponent {

    getDate(str) {
        if (str == null) return null;
        const num = parseInt(str, 10);
        if (isNaN(num)) return null;
        return new Date(num * 1000);
    }

    render() {
        const { classes, userLang, entry } = this.props;

        let displayDate;
        const updated = this.getDate(entry.time_last_updated);
        const published = this.getDate(entry.time_first_published);
        let text = "aktualisiert am: ";


        if (updated !== null && published !== null) {
            if(updated > published) {
                displayDate = updated;
            } else {
                displayDate =  published;
                text = "veröffentlicht am: ";
            }
        } else {
            if(updated != null) {
                displayDate = updated;
            } else {
                if (published != null) {
                    displayDate = published;
                    text = "veröffentlicht am: ";
                }

            }
        }

        if (displayDate == null) {
            return (<div></div>);
        }

        let dateStr = new Intl.DateTimeFormat('de-DE', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit'

        }).format(displayDate);
        dateStr = dateStr.replaceAll(" um ", ", ");
        dateStr = dateStr.replaceAll(":", ".");


        return (
            <div>
                <Typography
                    variant='timestamp'
                    component='p'
                    align='start'
                    classes={{ root: classes.timestamp }}
                >
                    {text + dateStr + " Uhr"}
                </Typography>

            </div>
        );
    }
}

TimestampCard.propTypes = {
    userLang: PropTypes.string,
    entry: PropTypes.object,
};

export default function _TimestampCard(props) {
    const classes = useStyles();
    return <TimestampCard {...props} classes={classes} />;
}
